export default function MobileCTA() {
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white border-t border-black/10 px-4 py-3">
      <a
        href="#contact"
        className="block text-center bg-[#0a7d4f] text-white py-3 rounded-full text-sm uppercase tracking-wide"
      >
        Enquire on WhatsApp
      </a>
    </div>
  );
}
